import {Input, Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: "colorText",
    pure: false,
    standalone: false
})
/**
 * Pipe to convert a hex rgba color string (e.g #ff0e0dff) to a contrasting color (black or white) for text on that color background
 */
export class ColorTextPipe implements PipeTransform {
    @Input() propertyName: string;

    transform(value: string, args?: string): any {
        if (!value || value === "#00000000") {
            return value;
        }
        const red: number = Number("0x" + value.substring(1, 3));
        const green: number = Number("0x" + value.substring(3, 5));
        const blue: number = Number("0x" + value.substring(5, 7));
        const alpha: number = Number("0x" + value.substring(7, 9));
        if (alpha < 160) {
            return "#000000FF";
        }
        const lightness: number = ((0.299 * red) + (0.587 * green) + (0.114 * blue)) / 255;
        return (lightness < 0.5) ? "#FFFFFFFF" : "#000000FF";
    }
}
